import { useNavigate } from 'react-router-dom';
import {
  Box,
  Button,
  Card,
  CardContent,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { useGetSalesReturnsQuery } from '../../../store/api/salesApi';
import { useGetCurrentCompanyQuery } from '../../../store/api/companyApi';

function SalesReturnsList() {
  const navigate = useNavigate();
  const { data, isLoading, error } = useGetSalesReturnsQuery({ limit: 50 });
  const { data: company } = useGetCurrentCompanyQuery();
  const currency = company?.currency || 'USD';

  const formatAmount = (value) => {
    const amount = Number(value || 0);
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency,
      }).format(amount);
    } catch (e) {
      return `${currency} ${amount.toFixed(2)}`;
    }
  };

  if (isLoading) return <Typography>Loading...</Typography>;
  if (error) return <Typography color="error">Error loading sales returns</Typography>;

  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 4 }}>
        <Typography variant="h4" component="h1" sx={{ fontWeight: 600 }}>
          Sales Returns
        </Typography>
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={() => navigate('/sales/returns/new')}
          sx={{ borderRadius: 2 }}
        >
          New Sales Return
        </Button>
      </Box>

      <Card>
        <CardContent>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow sx={{ bgcolor: 'grey.50' }}>
                  <TableCell sx={{ fontWeight: 600 }}>Return Number</TableCell>
                  <TableCell sx={{ fontWeight: 600 }}>Customer</TableCell>
                  <TableCell sx={{ fontWeight: 600 }}>Return Date</TableCell>
                  <TableCell sx={{ fontWeight: 600 }}>{`Total Amount (${currency})`}</TableCell>
                  <TableCell sx={{ fontWeight: 600 }}>Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data?.salesReturns?.length > 0 ? (
                  data.salesReturns.map((ret) => (
                    <TableRow key={ret.id} hover>
                      <TableCell sx={{ fontWeight: 500 }}>{ret.returnNumber}</TableCell>
                      <TableCell>{ret.customer?.name || '-'}</TableCell>
                      <TableCell>{new Date(ret.returnDate).toLocaleDateString()}</TableCell>
                      <TableCell sx={{ fontWeight: 600, color: 'primary.main' }}>
                        {formatAmount(ret.totalAmount)}
                      </TableCell>
                      <TableCell>
                        <IconButton
                          size="small"
                          color="primary"
                          onClick={() => navigate(`/sales/returns/${ret.id}`)}
                        >
                          <VisibilityIcon fontSize="small" />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={5} align="center" sx={{ py: 4 }}>
                      <Typography color="text.secondary">No sales returns found</Typography>
                      <Button
                        variant="outlined"
                        startIcon={<AddIcon />}
                        onClick={() => navigate('/sales/returns/new')}
                        sx={{ mt: 2 }}
                      >
                        Create First Sales Return
                      </Button>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </CardContent>
      </Card>
    </Box>
  );
}

export default SalesReturnsList;

